import React from 'react';
import '../style/BuyMeCoffeeButton.css'; // correct path

const BuyMeCoffeeButton = () => {
  return (
    <a 
      href="https://www.buymeacoffee.com/thepickykitty" 
      target="_blank" 
      rel="noopener noreferrer" 
      className="buy-me-coffee-link"
    >
      <img
        src="/buymeacoffee.png"
        alt="Buy Me A Coffee"
        className="buy-me-coffee-img"
      />
    </a>
  );
};

export default BuyMeCoffeeButton;
